import { Pipe, PipeTransform } from '@angular/core';

/**
 * EscapeCharsPipe
 */
@Pipe({
  name: 'escapeMed',
  pure: true,
  standalone: false,
})
export class EscapeMedPipe implements PipeTransform {
  /**
   * transform
   * @param {string} input
   * @returns {string}
   */
  transform(input: string): string {
    if (typeof input !== 'string') throw new Error('Input must be a string.');
    return input.replace(/MED-/g, '');
  }
}
